module.exports = __webpack_public_path__ + "img/vale_desactivado.1c3fca97.svg";